import { LazyItem, LazyItemType } from "@obg/common.lazy-loader";

import { SelfExclusionType } from "../self-exclusion/self-exclusion.const";

export const depositLimitLazyItem: LazyItem = {
	name: "DepositLimitModule",
	path: () => import("../deposit-limit/module"),
	type: LazyItemType.module,
};

export const depositLimitCalculatorLazyItem: LazyItem = {
	name: "DepositLimitCalculatorModule",
	path: () => import("../deposit-limit-calculator/deposit-limit-calculator.module"),
	type: LazyItemType.module,
};

export const bettingLimitLazyItem: LazyItem = {
	name: "BettingLimitModule",
	path: () => import("../betting-limit/betting-limit.module"),
	type: LazyItemType.module,
};

export const zhhBettingLimitLazyItem: LazyItem = {
	name: "ZhhBettingLimitModule",
	path: () => import("../betting-limit/zhh/zhh-betting-limit.module"),
	type: LazyItemType.module,
};

export const bettingLimitV2LazyItem: LazyItem = {
	name: "BettingLimitV2Module",
	path: () => import("../betting-limit/betting-limit-v2/betting-limit-v2.module"),
	type: LazyItemType.module,
};

export const netlossLimitLazyItem: LazyItem = {
	name: "NetlossLimitModule",
	path: () => import("../netloss-limit/netloss-limit.module"),
	type: LazyItemType.module,
};

export const selfExclusionLazyItem: LazyItem = {
	name: "SelfExclusionModule",
	path: () => import("../self-exclusion/self-exclusion.module"),
	type: LazyItemType.module,
};

export const indefiniteSelfExclusionLazyItem: LazyItem = {
	name: "SelfExclusionModule",
	path: () => import("../self-exclusion/self-exclusion.module"),
	type: LazyItemType.module,
	moduleData: { selfExclusionType: SelfExclusionType.Indefinite },
};

export const balanceLimitLazyItem: LazyItem = {
	name: "BalanceLimitModule",
	path: () => import("../balance-limit/balance-limit.module"),
	type: LazyItemType.module,
};

export const timeOffLazyItem: LazyItem = {
	name: "TimeOffModule",
	path: () => import("../time-off/time-off.module"),
	type: LazyItemType.module,
};

export const logoutCooldownLimitLazyItem: LazyItem = {
	name: "LogoutCooldownModule",
	path: () => import("../logout-cooldown/logout-cooldown.module"),
	type: LazyItemType.module,
};

export const loginLimitLazyItem: LazyItem = {
	name: "LoginLimitModule",
	path: () => import("../login-limit/login-limit.module"),
	type: LazyItemType.module,
};
